import request from '@/utils/request'

export const captainListApi = (data) => {
    return request({
        url: 'Users/List',
        method: 'post',
        data
    })
}

export const captainCheckinDaysApi = (data) => {
    return request({
        url: 'UserReviews/UsersList',
        method: 'post',
        data
    })
}

export const saveCaptainReviewApi = (data) => {
    return request({
        url: 'UserReviews/save',
        method: 'post',
        data
    })
}
